import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from '../../../../Autofacets-Core/src/app/utils/urls';
import { GetAllActiveDealerResponseModel, Promotions } from '../business-entities/promotions-model';


@Injectable({
  providedIn: 'root'
})
export class PromotionDataService {
  constructor(private dataProvider: DataService) {

  }

  async getPromotionList(promotionObj: any): Promise<GenericResponse<Array<Promotions>>> {
    return this.dataProvider.Post<GenericResponse<Array<Promotions>>>(Urls.GetPromotionList, promotionObj)
      .toPromise();
  }

  deletePromotion(promotionId: number) {
    return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeletePromotion, promotionId)
      .toPromise();
  }

  activeInactivePromotion(promotionObj: any): Promise<GenericResponse<boolean>> {
    return this.dataProvider.Post<GenericResponse<boolean>>(Urls.ActiveInactivePromotion, promotionObj)
      .toPromise();
  }

  async getPromotionById(promotionId: number): Promise<GenericResponse<any>> {
    return this.dataProvider.Get<GenericResponse<any>>
      (Urls.GetPromotion, promotionId).toPromise();
  }

  async addEditPromotion(model: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditPromotion, model).toPromise();
  }
  async activeInactiveDealer(model): Promise<GenericResponse<boolean>> {
    return this.dataProvider.Post<GenericResponse<boolean>>(Urls.ActiveInActiveDealerForPromotion, model)
      .toPromise();
  }
  getAllActiveDealer(): Promise<GenericResponse<Array<GetAllActiveDealerResponseModel>>>{
    return this.dataProvider.Get<GenericResponse<Array<GetAllActiveDealerResponseModel>>>(Urls.GetAllActiveDealerForPromotion).toPromise();
  }
}
